export const routeWithSearch = (pathname: string, search: string): string => {
  if (!search) {
    return pathname;
  }

  if (pathname.includes('?')) {
    return `${pathname}&${search.slice(1)}`;
  }

  return `${pathname}${search}`;
};
